module.exports = __webpack_public_path__ + "static/img/pitch_white_old.5b1058f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_white_old.png
// module id = Kn8P
// module chunks = 79